import { render, staticRenderFns } from "./GemaResult.vue?vue&type=template&id=ea7727d2&scoped=true&"
import script from "./GemaResult.vue?vue&type=script&lang=js&"
export * from "./GemaResult.vue?vue&type=script&lang=js&"
import style0 from "./GemaResult.vue?vue&type=style&index=0&id=ea7727d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7727d2",
  null
  
)

export default component.exports